import React, { useState, useEffect } from "react";
import { Table } from "react-bootstrap";
const CountdownTimer = ({ duration }) => {
  // Set the initial countdown time (in seconds)
  const [timeLeft, setTimeLeft] = useState(duration); // 60 seconds countdown
  const [isRunning, setIsRunning] = useState(true); // Track if the timer is running
  const [intervalId, setIntervalId] = useState(null); // To store the interval ID

  useEffect(() => {
    if (isRunning && timeLeft > 0) {
      // Start the countdown
      const id = setInterval(() => {
        setTimeLeft((prevTime) => prevTime - 1);
      }, 1000);
      setIntervalId(id);
    } else {
      // Stop the countdown when time reaches 0 or is stopped
      clearInterval(intervalId);
    }

    // Clean up interval when component unmounts or timer stops
    return () => clearInterval(intervalId);
  }, [isRunning, timeLeft]); // Effect runs when isRunning or timeLeft changes

  const toggleTimer = () => {
    setIsRunning(!isRunning); // Toggle start/stop of the timer
  };

  const resetTimer = () => {
    setTimeLeft(60); // Reset the countdown to initial value (e.g., 60 seconds)
    setIsRunning(false); // Stop the timer
  };

  const formatTime = (timeInSeconds) => {
    const days = Math.floor(timeInSeconds / (3600 * 24)); // Get the number of days
    const hours = Math.floor((timeInSeconds % (3600 * 24)) / 3600); // Get the number of hours
    const minutes = Math.floor((timeInSeconds % 3600) / 60); // Get the number of minutes
    const seconds = timeInSeconds % 60; // Get the remaining seconds

    // Format the time in day:hour:minute:second
    return `${days}:${hours < 10 ? "0" : ""}${hours}:${
      minutes < 10 ? "0" : ""
    }${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
  };

  const formatTimeTable = (timeInSeconds) => {
    const days = Math.floor(timeInSeconds / (3600 * 24)); // Get the number of days
    const hours = Math.floor((timeInSeconds % (3600 * 24)) / 3600); // Get the number of hours
    const minutes = Math.floor((timeInSeconds % 3600) / 60); // Get the number of minutes
    const seconds = timeInSeconds % 60; // Get the remaining seconds

    // Format the time in day:hour:minute:second
    // return `${days}:${hours < 10 ? "0" : ""}${hours}:${
    //   minutes < 10 ? "0" : ""
    // }${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
    return (
      <React.Fragment>
        <Table striped bordered hover>
          <tbody>
            <tr className="table-danger">
              <th>Days</th>

              <th>Hours</th>

              <th>Minutes</th>

              <th>seconds</th>
            </tr>
            <tr>
              <td>{days}</td>

              <td>{hours}</td>

              <td>{minutes}</td>

              <td>{seconds}</td>
            </tr>
          </tbody>
        </Table>
      </React.Fragment>
    );
  };
  return (
    <React.Fragment>
      {formatTimeTable(timeLeft)}
      {/* <span style={{ width: "100px" }}>
       
      
      </span> */}
    </React.Fragment>
  );
};

export default CountdownTimer;